/********************************************************************
 * Project: WDCK（2021）
 * Class: LanguageTranslateService
 * ----------------------------------------
 * <summary>
 * LanguageTranslateService
 * </summary>
 * <history>
 *      ThaiTV     2021/07/27      Create
 * </history>
 ********************************************************************/
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LanguageTranslateService {
    public currLangSubject = new BehaviorSubject<string>('jp');
    public currLanguage = this.currLangSubject.asObservable();

    constructor() {
    }
    setLanguage(pVal: string) {
        this.currLangSubject.next(pVal);
    }
    public getLanguage(): Observable<string> {
        return this.currLangSubject;
    }
}
